<template>
  <div class="company-bd">
    <div class="tab-box">
      <el-tabs v-model="active">
        <el-tab-pane :label="$t('company_yuan_gong')" v-if="funcView.company_user_list" name="member"></el-tab-pane>
        <el-tab-pane :label="$t('company_bu_men')" v-if="funcView.company_department_list" name="department"></el-tab-pane>
        <el-tab-pane :label="$t('company_gang_wei')" v-if="funcView.company_role_list" name="role"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 员工 -->
    <company-member v-if="active == 'member'"></company-member>
    <!-- 部门 -->
    <company-department v-if="active == 'department'"></company-department>
    <!-- 岗位 -->
    <company-role v-if="active == 'role'"></company-role>
  </div>
</template>

<script>
import companyMember from './company_member.vue';
import companyDepartment from './company_department.vue';
import companyRole from './company_role.vue';

// company_yuan_gong: 员工// company_bu_men: 部门// company_gang_wei: 岗位

export default {
  name: 'company',
  components: { companyMember, companyDepartment, companyRole },
  computed: {},
  data() {
    return {
      active: ''
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_company');},
  methods: {
    i18nCallback() {
      this.getFuncView(null, () => {
        if (this.funcView.company_user_list) {
          this.active = 'member';
        } else if (this.funcView.company_department_list) {
          this.active = 'department';
        } else if (this.funcView.company_role_list) {
          this.active = 'role';
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-bd {
  padding-left: 24px;
  padding-right: 24px;
  .tab-box {
    padding-top: 24px 0;
  }
}
</style>
